// extracted by mini-css-extract-plugin
export default {"icon":"RequiredIcon__icon___WgTp1"};